import { LISTAR_CATREGIMENFISCAL } from "../../types";

// eslint-disable-next-line import/no-anonymous-default-export
export default (state, action) => {
  switch (action.type) {
    case LISTAR_CATREGIMENFISCAL:
      return {
        ...state,
        catRegimenFiscales: action.payload,
      };
    default:
      return state;
  }
};
